import { motion } from 'framer-motion'
import Lottie from 'lottie-react'
import { forwardRef, useEffect, useState } from 'react'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import LoadingAnimation from '@/assets/lottie/loading-animation.json'

type Props = {
  small?: boolean
  cancellable?: boolean
  style?: React.CSSProperties
  onCancel?: () => void
}

const Loader = forwardRef<HTMLDivElement, Props>(
  (
    {
      small,
      cancellable = false,
      onCancel = () => {
        window.location.href = '/'
      },
      style,
    }: Props,
    ref,
  ) => {
    const [showCancelButton, setShowCancelButton] = useState(false)

    useEffect(() => {
      const timer = setTimeout(() => {
        setShowCancelButton(true)
      }, 5000)

      return () => clearTimeout(timer)
    }, [])

    return (
      <div ref={ref}>
        <Flex
          flexDirection='column'
          flexGrow={1}
          justifyContent='center'
          alignItems='center'
          style={{ height: small ? 'auto' : '80vh', ...style }}
        >
          <Lottie animationData={LoadingAnimation} loop style={{ height: 40 }} />
          {showCancelButton && cancellable && (
            <Button inline variant='Secondary' onClick={onCancel}>
              Terug naar beginscherm
            </Button>
          )}
        </Flex>
      </div>
    )
  },
)
Loader.displayName = 'Loader'

const AnimatedLoader = motion(Loader)

export { AnimatedLoader, Loader }
